<template>
  <svg
    width="186"
    height="200"
    viewBox="0 0 186 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M117.308 65.7698C114.974 65.7698 113.064 67.6779 113.064 70.01V92.1832L119.641 85.6122H133.717C136.051 85.6122 137.961 83.704 137.961 81.3719V70.01C137.961 67.6779 136.051 65.7698 133.717 65.7698H117.308Z"
      fill="#B3E0D0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M117.35 80.8913H120.393V76.9139H117.35V80.8913Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M121.386 80.8913H124.428V74.0758H121.386V80.8913Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M125.225 80.8917H128.268V71.333H125.225V80.8917Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M129.065 80.8917H132.108V69.4214H129.065V80.8917Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M132.108 76.6645C130.558 76.6645 129.301 77.9199 129.301 79.4691C129.301 81.0182 130.558 82.2737 132.108 82.2737C133.658 82.2737 134.915 81.0182 134.915 79.4691C134.915 77.9199 133.658 76.6645 132.108 76.6645Z"
      fill="#FFFFFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M133.173 81.033L133.674 80.5334L132.608 79.4689L133.652 78.4256L133.152 77.926L132.108 78.9691L131.043 77.9047L130.543 78.4047L131.608 79.4689L130.563 80.5122L131.064 81.0122L132.108 79.9687L133.173 81.033Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M131.814 185.307C127.808 184.141 124.289 181.743 120.886 179.423C117.176 176.895 113.34 174.281 108.969 173.389C103.732 172.321 98.2992 173.823 93.0461 175.276C87.507 176.808 81.7796 178.392 76.1535 177.048C72.9842 176.29 70.4548 174.653 69.0309 172.44C67.2983 169.746 67.42 166.235 69.3199 164.09C70.3724 162.902 72.0877 162.241 73.7938 162.363L73.7177 163.42C72.3342 163.322 70.9524 163.847 70.1142 164.793C68.5482 166.561 68.4665 169.602 69.9232 171.867C71.1982 173.849 73.4985 175.323 76.4 176.016C81.7623 177.298 87.3542 175.751 92.7632 174.254C98.1368 172.768 103.693 171.231 109.181 172.35C113.761 173.285 117.687 175.96 121.484 178.548C124.818 180.82 128.267 183.17 132.111 184.29C140.389 186.701 148.99 183.308 157.308 180.028L158.241 179.66C166.887 176.258 176.844 173.38 185.142 177.825L184.64 178.759C176.725 174.519 167.05 177.334 158.63 180.646L157.698 181.014C151.246 183.558 144.628 186.168 138.034 186.168C135.955 186.168 133.881 185.909 131.814 185.307Z"
      fill="#B3E0D0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M70.9344 147.424L72.8315 147.337L74.8997 182.036C79.5938 181.932 83.4079 182.604 84.0332 183.624C84.9321 183.607 85.8463 183.715 86.748 183.823C88.0202 183.975 89.2803 184.523 90.162 185.427C90.162 185.427 90.6593 186.005 90.8333 186.314C91.6442 187.753 91.4313 189.785 90.1316 190.809C88.8319 191.834 86.5535 191.384 85.9774 189.837C85.5583 188.71 86.1005 187.391 87.0289 186.623C87.501 186.233 88.0531 185.966 88.6384 185.782C87.5665 184.671 85.7668 184.466 83.7193 184.57C82.5222 185.526 78.7982 186.331 74.3643 186.5C73.9218 186.517 73.486 186.527 73.0585 186.531L72.2204 187.167C73.4013 186.886 74.7774 187.232 75.4794 188.244C76.6536 189.937 75.5947 192.62 73.6128 193.202C71.6227 193.787 69.2998 192.178 69.1594 190.117C69.047 188.472 70.3522 186.924 71.927 186.525C68.1735 186.452 65.2591 185.863 64.5837 185.016C63.8289 185.054 62.446 185.16 61.7503 185.449C60.7636 185.858 60.1807 186.707 60.5528 187.704C60.6714 188.022 60.8871 188.287 61.1033 188.553L61.1034 188.553C61.2914 188.785 61.4798 189.016 61.605 189.284C62.2487 190.658 60.6441 192.34 59.1516 192.035C57.6591 191.731 56.777 189.978 57.0943 188.494C57.4119 187.01 58.6564 185.859 60.0513 185.249C61.4462 184.638 62.9917 184.481 64.5079 184.332L64.5177 184.343C65.0898 183.326 68.5813 182.408 73.0028 182.119L70.9344 147.424Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.4072 147.219C69.0235 153.756 94.8272 147.219 94.8272 147.219L50.6327 129.934C50.6327 129.934 41.791 140.682 55.4072 147.219Z"
      fill="#EB5757"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M168.581 161.706L177.423 153.219L168.405 154.816L163.276 148.279L160.978 153.219L168.581 161.706Z"
      fill="#EB5757"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M99.4331 196.243L103.86 199.339H91.8352L101.031 183.084L106.336 185.204L99.4331 196.243Z"
      fill="#EB5757"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M139.227 105.876C144.56 112.59 166.99 151.727 166.99 151.727L161.331 156.15L131.943 122.775L109.872 127.077L106.336 109.233C106.336 109.233 133.894 99.162 139.227 105.876Z"
      fill="#3F2C48"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M74.3289 118.407C64.0339 123.32 55.2859 129.056 50.6331 136.972C50.6331 136.972 51.3963 138.416 53.9353 140.341C63.2322 130.663 70.9793 124.171 78.5482 118.926C75.902 118.581 74.3289 118.407 74.3289 118.407Z"
      fill="#3F2C48"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M78.5478 118.926C69.0698 124.415 60.4417 131.02 53.9352 140.341C60.0523 144.979 76.488 152.408 117.476 149.162L98.378 185.558L105.451 188.031C105.451 188.031 146.831 145.982 136.221 135.028C127.467 125.99 91.0291 120.552 78.5478 118.926Z"
      fill="#523B5D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M65.3252 29.8712C64.7678 29.874 64.2228 29.8772 63.6944 29.8804C53.5384 29.9436 43.6559 33.1546 35.4659 39.1086C40.8032 47.7782 52.22 51.6726 61.2428 45.2751C66.2833 41.498 67.3924 35.1984 65.3252 29.8712Z"
      fill="#F9B6A8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43.954 6.14079L41.5551 12.1479L42.5839 12.2016L43.954 9.87931L47.096 10.8316L47.8589 9.32984L52.3077 10.4694L54.2578 6.14079H43.954Z"
      fill="#F9B6A8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.3114 22.0712C38.8439 25.1337 44.0311 33.3563 44.0311 33.3563L52.0477 29.2115L52.9931 25.4486C52.9931 25.4486 54.2875 19.1267 53.4034 18.5376C52.5192 17.9489 50.8686 22.1892 50.8686 22.1892L45.4939 15.5931L40.1408 17.0065C40.1408 17.0065 35.779 19.009 37.3114 22.0712Z"
      fill="#F9B6A8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M51.8398 23.9832C51.7425 23.9719 51.6732 23.8843 51.6845 23.7871C51.8299 22.5337 52.1344 21.3009 52.5902 20.1235C52.6256 20.0323 52.7289 19.9871 52.8191 20.0224C52.9103 20.0574 52.9556 20.1599 52.9202 20.2507C52.4753 21.4005 52.1775 22.604 52.0357 23.8281C52.0254 23.9182 51.9487 23.9843 51.8603 23.9843C51.8536 23.9843 51.8465 23.9839 51.8398 23.9832Z"
      fill="#CC395D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M47.096 43.3906C51.4578 46.2175 61.125 42.5659 58.7671 34.6744C56.4092 26.7828 52.8725 25.3694 51.4578 22.1892C51.4578 22.1892 51.3401 15.1221 47.5675 16.5355C47.5675 16.5355 45.9173 11.5885 40.8478 13.5906C40.8478 13.5906 37.3111 9.23266 34.7176 11.4705C32.1242 13.7086 33.6566 19.2443 39.669 17.9489C45.6814 16.6532 46.5691 16.8888 46.5691 16.8888C46.5691 16.8888 48.3929 21.0111 49.8076 22.8959C51.2223 24.7804 51.8773 28.4316 48.249 30.7874C44.6203 33.1433 44.6203 33.9676 44.6203 33.9676C44.6203 33.9676 42.7342 40.5638 47.096 43.3906Z"
      fill="#FB9300"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43.2127 37.5012C43.2127 37.5012 47.096 35.0277 47.096 32.5542C47.096 32.5542 50.5736 33.9676 53.403 32.3775C53.403 32.3775 49.2251 27.4305 45.1544 29.904C45.1544 29.904 42.5125 33.0843 43.2127 37.5012Z"
      fill="#F57100"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M47.096 30.0807C47.096 30.0807 44.7971 24.957 43.5593 25.4871C42.3215 26.0171 44.7971 31.3175 44.7971 31.3175L47.096 30.0807Z"
      fill="#CC395D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M45.8617 22.1892C45.4709 22.1892 45.1544 22.5055 45.1544 22.8959C45.1544 23.2864 45.4709 23.6026 45.8617 23.6026C46.2525 23.6026 46.569 23.2864 46.569 22.8959C46.569 22.5055 46.2525 22.1892 45.8617 22.1892Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.8481 24.7422C40.4573 24.7422 40.1407 25.0585 40.1407 25.4489C40.1407 25.8394 40.4573 26.1556 40.8481 26.1556C41.2389 26.1556 41.5554 25.8394 41.5554 25.4489C41.5554 25.0585 41.2389 24.7422 40.8481 24.7422Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.2988 20.5867L38.4131 22.9429L37.8603 22.5012L39.7461 20.145L40.2988 20.5867Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43.6389 20.5768C43.8582 20.1457 44.2762 19.8259 44.7859 19.6991C45.2959 19.5722 45.8154 19.6585 46.2112 19.9365L45.8044 20.5146C45.5767 20.3549 45.2676 20.3076 44.957 20.3846C44.6462 20.4623 44.3958 20.6489 44.2695 20.897L43.6389 20.5768Z"
      fill="#3A3B39"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M69.5317 29.8535C68.0506 29.8581 66.6458 29.8641 65.3252 29.8712C67.3924 35.1984 66.2833 41.498 61.2428 45.2751C52.22 51.6726 40.8032 47.7782 35.466 39.1086C35.0394 39.4189 34.6161 39.7344 34.1988 40.0595C33.4387 40.6517 32.6649 41.2737 31.8812 41.9242C39.0341 52.2323 54.2161 56.0175 64.7795 48.1019C70.6766 43.491 71.1813 36.4659 69.5317 29.8535Z"
      fill="#FFFFFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M53.7121 5.34574L51.8599 10.8313L105.275 30.0252C90.7632 29.8507 78.6504 29.8252 69.5317 29.8535C71.1813 36.4659 70.6766 43.491 64.7795 48.1019C54.2161 56.0175 39.0341 52.2323 31.8812 41.9242C24.7915 47.8079 16.8509 56.1129 10.3144 67.3599C-4.46402 92.7892 1.61838 112.943 5.36303 114.003L15.7963 99.3387L32.7724 73.9574C36.075 97.715 41.6201 119.143 50.6327 136.971C75.7432 114.71 106.336 109.233 106.336 109.233L89.5363 54.2857C89.5363 54.2857 124.55 40.5048 124.55 32.5542C124.55 9.75634 53.7121 5.34574 53.7121 5.34574Z"
      fill="#00AEC8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M66.6963 173.448C59.7832 172.87 53.902 170.949 49.2152 167.738C43.7627 164.004 40.0406 158.302 39.259 152.486C38.2178 144.74 41.9791 137.292 46.1987 130.396L46.7862 129.438L47.6905 129.993L47.1041 130.949C42.9864 137.678 39.3135 144.927 40.3105 152.345C41.0528 157.868 44.6058 163.296 49.8154 166.864C54.348 169.969 60.0576 171.829 66.7848 172.392C69.3082 172.603 72.192 172.627 74.4696 171.207C75.6827 170.449 76.6224 169.113 76.9216 167.719C77.0811 166.977 77.1299 165.882 76.4597 164.882C75.8932 164.037 74.894 163.504 73.7181 163.42L73.7941 162.363C75.2986 162.47 76.5917 163.174 77.3411 164.292C78.0258 165.313 78.2451 166.609 77.9593 167.941C77.6017 169.606 76.4799 171.202 75.0316 172.105C73.1932 173.252 71.0009 173.554 68.9704 173.554C68.1775 173.554 67.4093 173.508 66.6963 173.448Z"
      fill="#B3E0D0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M46.7862 129.438L47.055 129.002C50.8269 122.875 54.7271 116.539 55.182 109.472C55.316 107.388 55.1402 105.244 54.9708 103.17C54.7561 100.545 54.534 97.8302 54.9227 95.1577C55.664 90.0666 59.7648 85.0376 64.7041 85.6655L64.5705 86.7175C60.2511 86.1662 56.6419 90.7164 55.9728 95.31C55.601 97.8638 55.8178 100.517 56.0283 103.084C56.2009 105.196 56.3795 107.379 56.2408 109.539C55.769 116.87 51.7984 123.32 47.9586 129.557L47.6905 129.993L46.7862 129.438Z"
      fill="#E2F3EB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.7963 99.3387C10.9945 103.608 7.28311 108.386 5.36304 114.003C7.26507 114.542 13.1438 121.07 52.5779 98.1019L50.1022 92.0949L15.7963 99.3387Z"
      fill="#00AEC8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M54.523 88.3846L60.0049 90.674L57.5292 93.3316H55.0535L51.8599 96.3602L50.1022 92.0949L54.523 88.3846Z"
      fill="#F9B6A8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M86.8838 45.4517L91.8352 53.3503L89.5363 54.2857L86.8838 45.4517Z"
      fill="#0080A3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M110.58 32.3775L99.9696 30.0252H105.275L110.58 32.3775Z"
      fill="#0080A3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.9846 68.7733L33.5056 78.9514L32.7724 73.9574L36.9846 68.7733Z"
      fill="#0080A3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M120.313 143.685L113.064 149.476L117.476 149.162L120.313 143.685Z"
      fill="#3F2C48"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.731 22.9811L16.7197 23.6949L16.6359 22.992L22.6475 22.2782L22.731 22.9811Z"
      fill="#B3E0D0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.2409 14.4433L24.0375 15.1203L10.9623 11.1966L11.1661 10.5196L24.2409 14.4433Z"
      fill="#B3E0D0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M64.9927 87.5814H69.1441V85.0401H64.9927V87.5814Z"
      fill="#E2F3EB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.351 5.80192L24.9192 6.36164L17.386 0.560579L17.8179 0.000862122L25.351 5.80192Z"
      fill="#B3E0D0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M64.6409 88.3846H67.1845V84.2369H64.6409V88.3846Z"
      fill="#B3E0D0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M49.9402 91.5648C49.9402 91.5648 25.942 97.1963 15.7963 99.3387L13.6594 102.342L50.1022 92.0949L49.9402 91.5648Z"
      fill="#00AEC8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M67.2481 116.196C66.8803 115.831 67.1116 115.203 67.6286 115.164L91.8352 113.309L79.8104 128.667L67.2481 116.196Z"
      fill="#E2F3EB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M89.4988 103.364C89.7344 102.749 90.3254 102.342 90.985 102.342H118.721C119.78 102.342 120.543 103.356 120.25 104.373L113.668 127.158C113.41 128.052 112.591 128.667 111.659 128.667H79.8104L89.4988 103.364Z"
      fill="#B3E0D0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M103.327 112.243C101.524 112.243 100.062 113.703 100.062 115.505C100.062 117.306 101.524 118.767 103.327 118.767C105.13 118.767 106.592 117.306 106.592 115.505C106.592 113.703 105.13 112.243 103.327 112.243Z"
      fill="#E2F3EB"
    />
  </svg>
</template>
